import React from 'react';
import ReactTooltip from 'react-tooltip';
import { DropdownButton, Dropdown } from 'react-bootstrap';

//import { Link } from "react-router-dom";

//import { user_access_level, apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import { owner_perms, org_friendly_url, user_access_level, user_account_level } from "Api/Api";
// , organization_user_access_level
//import axios from "axios";

import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

//import { assembleNickname } from "utils/Helper.js";

//import './style.css';


function DownloadAssetsButton (props) {
  const user_context = React.useContext(UserContext);
  //const [entity_info, setEntityInfo] = React.useState({});
  const [assets_array, setAssetsArray] = React.useState([]);

  // on mount
  React.useEffect(() => {
    //console.log("DownloadAssetsButton useEffect",props.entity_info);
    
    let tmp_assets_array = [];
    
    if (props.entity_info.entity_type === 'events') {
      if (props.entity_info.event_pptx_url) {
        let asset_download_obj = {
            asset_url: props.entity_info.event_pptx_url,
            dropdown_option: <i className="fa fa-file-powerpoint-o"> Pptx (Powerpoint) File</i>
        }
        tmp_assets_array.push(asset_download_obj);
      }
      if (props.entity_info.download_zoom_webinar_video_url) {
        let asset_download_obj = {
            asset_url: props.entity_info.download_zoom_webinar_video_url,
            dropdown_option: <i className="fa fa-file-video-o"> Webinar Mp4 (Video) File</i>
        }
        tmp_assets_array.push(asset_download_obj);
      }
      if (props.entity_info.zoom_webinar_audio_url) {
          let asset_download_obj = {
              asset_url: props.entity_info.zoom_webinar_audio_url,
              dropdown_option: <i className="fa fa-file-audio-o"> Webinar M4a (Audio) File</i>
          }
          tmp_assets_array.push(asset_download_obj);
      }
      setAssetsArray(tmp_assets_array);
    } else if (props.entity_info.entity_type === 'presentations') { {
        let assets_array = [];
        // all users get this for now
        if (props.entity_info.presentation_pptx_url) {
            let asset_download_obj = {
                asset_url: props.entity_info.presentation_pptx_url,
                dropdown_option: <i className="fa fa-file-powerpoint-o"> Pptx (Powerpoint) File</i>
            }
            tmp_assets_array.push(asset_download_obj);
        }
        // only pro/workspace users get this for now
        if (org_friendly_url || user_access_level === 'admin' || user_account_level === 'private' || (user_context.user_info.events && user_context.user_info.events.length > 0)) {
            if (props.entity_info.download_presentation_video_url) {
                if (!props.entity_info.create_presentation_video_start_time || (props.entity_info.create_presentation_video_start_time && props.entity_info.create_presentation_video_end_time)) {
                  let asset_download_obj = {
                      asset_url: props.entity_info.download_presentation_video_url,
                      dropdown_option: <i className="fa fa-file-video-o"> Mp4 (Video) File</i>
                  }
                  tmp_assets_array.push(asset_download_obj);
                }
            }
            if (!props.entity_info.create_presentation_video_start_time || (props.entity_info.create_presentation_video_start_time && props.entity_info.create_presentation_video_end_time) || props.entity_info.legacy_oid) {
              if (props.entity_info.download_audio_url) {
                  let asset_download_obj = {
                      asset_url: props.entity_info.download_audio_url,
                      dropdown_option: <i className="fa fa-file-audio-o"> Mp3 (Audio) File</i>
                  }
                  tmp_assets_array.push(asset_download_obj);
              } else if (props.entity_info.audio_url) {
                  let asset_download_obj = {
                      asset_url: props.entity_info.audio_url,
                      dropdown_option: <i className="fa fa-file-audio-o"> Mp3 (Audio) File</i>
                  }
                  tmp_assets_array.push(asset_download_obj);
              }
            }
            if (props.entity_info.download_raw_image_zip_url) {
                let asset_download_obj = {
                    asset_url: props.entity_info.download_raw_image_zip_url,
                    dropdown_option: <i className="fa fa-file-archive-o"> Slide Images (Zip) File</i>
                }
                tmp_assets_array.push(asset_download_obj);
            }
        } else if (owner_perms.organizations) {
            // remind that they need to be in team
            let asset_download_obj = {
                //asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-video-o"> Mp4 (Video) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create Team View*</span>
                    </React.Fragment>

            }
            tmp_assets_array.push(asset_download_obj);
            asset_download_obj = {
                //asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-audio-o"> Mp3 (Audio) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create Team View*</span>
                    </React.Fragment>
            }
            tmp_assets_array.push(asset_download_obj);
            asset_download_obj = {
                //asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-archive-o"> Slide Images (Zip) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create Team View*</span>
                    </React.Fragment>
            }
            tmp_assets_array.push(asset_download_obj);
        } else {
            // upsell
            let asset_download_obj = {
                asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-video-o"> Mp4 (Video) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create PRO*</span>
                    </React.Fragment>

            }
            tmp_assets_array.push(asset_download_obj);
            asset_download_obj = {
                asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-audio-o"> Mp3 (Audio) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create PRO*</span>
                    </React.Fragment>
            }
            tmp_assets_array.push(asset_download_obj);
            asset_download_obj = {
                asset_url: local_routes.pricing,
                dropdown_option:
                    <React.Fragment>
                        <i className="fa fa-file-archive-o"> Slide Images (Zip) File</i>
                        <span style={{ fontSize: "smaller",color: "#16a085" }}> *Requires PK Create PRO*</span>
                    </React.Fragment>
            }
            tmp_assets_array.push(asset_download_obj);
        }
        setAssetsArray(tmp_assets_array);
      }
    }
    
  }, [props.entity_info,user_context]);

  if (assets_array.length === 0) {
    return (<React.Fragment></React.Fragment>)
  }
  
  return (
    <React.Fragment>
      { props.entity_info.editable &&
        <React.Fragment>
        <DropdownButton
          data-tip="Download File"
          title={<i className="fa fa-download"></i>}
          alignRight
          drop={'left'}
          size="sm"
          variant="outline-secondary"
        >
        {
          assets_array.map((item,index) => {
            return (
              <Dropdown.Item
                key={index}
                href={item.asset_url}
                rel="noopener noreferrer"
              >
                {item.dropdown_option}
              </Dropdown.Item>
            );
          })
        }
        </DropdownButton>
        <ReactTooltip/>
        </React.Fragment>
      }
    </React.Fragment>
  );
}

export default DownloadAssetsButton;